import { plainToInstance } from "class-transformer";
import VueI18n from "vue-i18n";

import { VueComponent } from "../../../../../types/VueComponent";
import { BasePeriodConditionBuilder } from "../BaseCondition/BasePeriodConditionBuilder";
import { PeriodConditionsTypeEnum } from "../types";
import { DateInterval } from "./DateInterval";

export class DateIntervalConditionBuilder extends BasePeriodConditionBuilder {
  type: PeriodConditionsTypeEnum = PeriodConditionsTypeEnum.DateInterval;

  view: Partial<{ setting: VueComponent; preview: VueComponent }> = {
    setting: () => import('./DateIntervalSetting.vue')
  }

  getModel(): DateInterval {
    return plainToInstance(DateInterval, {
      type: this.type,
      values: [],
    })
  }
}

export const DateIntervalBuilder = new DateIntervalConditionBuilder()
